import React from 'react';
import { Link } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core';

import classes from '../../css/getCSS';
import * as routes from '../../config/routes';


const commonMobileNavItems = (props) => {
  return (
    <List>
        {
        props.displayLogin && <Link to="" className={classes.linkDeCSS} onClick={props.handleClickOpen}>
            <ListItem>
                <ListItemText primary="Login" />
            </ListItem>
        </Link>
        }
      <Link to={formatRoute(routes.STATIC_PAGES, { page: 'about' })} className={classes.linkDeCSS}>
        <ListItem>
          <ListItemText primary="About" />
        </ListItem>
      </Link>
      <Link to={formatRoute(routes.STATIC_PAGES, { page: 'services' })} className={classes.linkDeCSS}>
        <ListItem>
          <ListItemText primary="Services" />
        </ListItem>
      </Link>
      <Link to={formatRoute(routes.EVENTS)} className={classes.linkDeCSS}>
        <ListItem>
          <ListItemText primary="Events" />
        </ListItem>
      </Link>
      <Link to={formatRoute(routes.NEWS)} className={classes.linkDeCSS}>
        <ListItem>
          <ListItemText primary="News" />
        </ListItem>
      </Link>
      <Link to={formatRoute(routes.GALLERY)} className={classes.linkDeCSS}>
        <ListItem>
          <ListItemText primary="Gallery" />
        </ListItem>
      </Link>
      <Link to={formatRoute(routes.STATIC_PAGES, { page: 'faqs' })} className={classes.linkDeCSS}>
        <ListItem>
          <ListItemText primary="FAQs" />
        </ListItem>
      </Link>
    </List>
  );
};

export default commonMobileNavItems;



// WEBPACK FOOTER //
// ./src/common/components/CommonMobileNavItems.js